import { storageDomain } from '../config'
import { getItem, setItem } from './storage'
import dayjs from 'dayjs'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export function getCnTime() {
  const hour = new Date().getHours()
  const thisTime = hour < 8 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 18 ? '下午好' : '晚上好'
  return thisTime
}

export function getDateTime(addDay = 0, timeFormat = 'HH:mm:ss') {
  return dayjs()
    .add(addDay, 'day')
    .format('YYYY-MM-DD ' + timeFormat)
}

export function getDate(addDay = 0) {
  return dayjs().add(addDay, 'day').format('YYYY-MM-DD')
}

export function getRandomNum() {
  const date = new Date()
  return `${date.getFullYear()}${
    date.getMonth() + 1
  }${date.getDate()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}${date.getUTCMilliseconds()}`
}

export function getColumn(columnName, array) {
  let columnArr = []
  if (!array || array.length == 0 || !Object.prototype.hasOwnProperty.call(array[0], columnName)) {
    return columnArr
  }
  for (var item of array) {
    columnArr.push(item[columnName])
  }
  return columnArr
}

export function getColumnValue(columnName, array) {
  if (!array || array.length == 0 || !Object.prototype.hasOwnProperty.call(array[0], columnName)) {
    return ''
  }
  let columnValues = []
  for (var item of array) {
    if (item[columnName] != null && item[columnName] != '') {
      columnValues.push(item[columnName])
    }
  }
  return columnValues.join(',')
}

export function getDatePickerOptions(withTime = false) {
  const startFormat = 'YYYY-MM-DD' + (withTime ? ' 00:00:00' : '')
  const endFormat = 'YYYY-MM-DD' + (withTime ? ' 23:59:59' : '')
  return {
    shortcuts: [
      {
        text: '今日',
        onClick(picker) {
          const today = dayjs()
          const start = today.format(startFormat)
          const end = today.format(endFormat)
          picker.$emit('pick', [start, end])
        },
      },
      {
        text: '昨日',
        onClick(picker) {
          const yestoday = dayjs().subtract(1, 'day')
          const start = yestoday.format(startFormat)
          const end = yestoday.format(endFormat)
          picker.$emit('pick', [start, end])
        },
      },
      {
        text: '七日内',
        onClick(picker) {
          const start = dayjs().subtract(6, 'day').format(startFormat)
          const end = dayjs().format(endFormat)
          picker.$emit('pick', [start, end])
        },
      },
      {
        text: '本月',
        onClick(picker) {
          const start = dayjs().startOf('month').format(startFormat)
          const end = dayjs().format(endFormat)
          picker.$emit('pick', [start, end])
        },
      },
      {
        text: '三个月内',
        onClick(picker) {
          const start = dayjs().subtract(2, 'month').format(startFormat)
          const end = dayjs().format(endFormat)
          picker.$emit('pick', [start, end])
        },
      },
      {
        text: '半年内',
        onClick(picker) {
          const start = dayjs().subtract(5, 'month').format(startFormat)
          const end = dayjs().format(endFormat)
          picker.$emit('pick', [start, end])
        },
      },
      {
        text: '今年内',
        onClick(picker) {
          const start = dayjs().startOf('year').format(startFormat)
          const end = dayjs().format(endFormat)
          picker.$emit('pick', [start, end])
        },
      },
    ],
  }
}

export function getDateTimePickerOptions() {
  return {
    shortcuts: [
      {
        text: '今日',
        onClick(picker) {
          const time = dayjs().format('YYYY-MM-DD HH:mm:ss')
          picker.$emit('pick', time)
        },
      },
      {
        text: '昨日',
        onClick(picker) {
          const time = dayjs().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
          picker.$emit('pick', time)
        },
      },
      {
        text: '一周前',
        onClick(picker) {
          const time = dayjs().subtract(6, 'day').format('YYYY-MM-DD HH:mm:ss')
          picker.$emit('pick', time)
        },
      },
    ],
  }
}

export async function getDeviceInfo() {
  const cacheKey = 'device_info'
  const cacheData = getItem(cacheKey)
  let deviceInfo = null
  if (cacheData) {
    try {
      deviceInfo = JSON.parse(cacheData)
    } catch {
      deviceInfo = null
    }
  }
  if (!deviceInfo) {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    deviceInfo = {
      deviceId: result?.visitorId ?? crypto.randomUUID(),
      deviceName: result.components?.platform?.value ?? '',
    }
    setItem(cacheKey, JSON.stringify(deviceInfo))
  }
  return deviceInfo
}
